import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "../../lib/CustomButton";

interface Props {
  selected: boolean;
  toggleOption: () => void;
  text: string;
  disabled?: boolean;
  isTopWinner?: boolean;
  isProductBox?: boolean;
  outOfStock?: boolean;
}

const ButtonOption: React.FC<Props> = ({
  selected,
  toggleOption,
  text,
  disabled = false,
  isTopWinner = false,
  isProductBox,
  outOfStock,
}) => {
  return isProductBox ? (
    <CustomButton
      type={selected ? BtnTypes.secondary : BtnTypes.neutral}
      size={BtnSizes.option}
      radius={BtnRadius.semi_small}
      disabled={disabled || outOfStock}
      onClick={disabled ? () => {} : toggleOption}
      style={isProductBox ? { height: 16 } : undefined}
      className=""
    >
      {text}
    </CustomButton>
  ) : (
    <CustomButton
      type={
        selected
          ? BtnTypes.primary
          : isTopWinner
          ? BtnTypes.secondary_no_border
          : BtnTypes.secondary
      }
      size={BtnSizes.option}
      radius={isTopWinner ? BtnRadius.medium : BtnRadius.small}
      disabled={disabled || outOfStock}
      onClick={disabled ? () => {} : toggleOption}
    >
      {text}
    </CustomButton>
  );
};

export default ButtonOption;
